export const theme = {
  colors: {
    primary: '#A855F7', // Brighter Purple-500
    primaryDark: '#9333EA', // Purple-600
    primaryLight: '#C084FC', // Purple-400
    background: '#1E1B26', // Dark purple-tinted background
    surface: '#2D2A3A', // Slightly lighter surface
    surfaceLight: '#3D3A4A', // Card backgrounds
    text: '#F8FAFC', // Nearly white
    textSecondary: '#CBD5E1', // Light gray
    textMuted: '#94A3B8', // Muted gray
    border: '#475569', // Border color
    accent: '#EC4899', // Pink accent for highlights
    success: '#10B981',
    warning: '#F59E0B',
    error: '#EF4444',
  },
  
  spacing: {
    xs: '0.25rem',
    sm: '0.5rem',
    md: '1rem',
    lg: '1.5rem',
    xl: '2rem',
    xxl: '3rem',
  },
  
  borderRadius: {
    sm: '0.25rem',
    md: '0.5rem',
    lg: '0.75rem',
    xl: '1rem',
  },
  
  shadows: {
    sm: '0 1px 2px 0 rgb(0 0 0 / 0.05)',
    md: '0 4px 6px -1px rgb(0 0 0 / 0.1)',
    lg: '0 10px 15px -3px rgb(0 0 0 / 0.1)',
    xl: '0 20px 25px -5px rgb(0 0 0 / 0.1)',
  },
  
  transitions: {
    fast: '150ms ease-in-out',
    normal: '250ms ease-in-out',
    slow: '350ms ease-in-out',
  },
  
  breakpoints: {
    sm: '640px',
    md: '768px',
    lg: '1024px',
    xl: '1280px',
  },
  
  zIndex: {
    dropdown: 1000,
    sticky: 1020,
    fixed: 1030,
    modal: 1040,
    popover: 1050,
    tooltip: 1060,
  },
} as const;

export type Theme = typeof theme;